import { Encoder } from 'io-ts';

export function encodeJson<T1, T2>(encoder: Encoder<T2, T1>, rawResults: T2) {
    const encodeResult = encoder.encode(rawResults);
    return encodeResult;
}
